import React, { FunctionComponent } from 'react';
import Image from '../../Article/Image';

export type ArticleImageProps = {
  node: {
    alt?: string;
    caption?: string;
    hotspot?: {
      x?: number;
      y?: number;
    };
    asset: {
      _ref: string;
    };
  };
};

const ArticleImage: FunctionComponent<ArticleImageProps> = (props) => {
  const { alt = '', caption, asset, hotspot } = props.node || {};

  return <Image id={asset._ref} alt={alt} caption={caption} hotspot={hotspot} />;
};

const articleImageRenderer = (props: ArticleImageProps) => {
  return <ArticleImage {...props} />;
};

export default articleImageRenderer;
